<kh-question-text *ngIf="utils.isSimpleAnswer(answerType)" [question]="choice" [textProperty]="textProperty" class="AnswerText TeacherAnswerText"></kh-question-text>
                  

<div *ngIf="utils.isFreeForm(answerType, manipulativeType)" class="form-control RenderMath GsAnswerPreviewField" [innerHTML]="choice.AnswerText | unsafeHtml">
</div>

<kh-question-text *ngIf="utils.isGeneralManipulative(answerType, manipulativeType)" [question]="choice" textProperty="RenderQuestion" class="QuestionText QuestionTextTeacher"></kh-question-text>  
<kh-question-text *ngIf="utils.isImageSwap(answerType, manipulativeType)" class="QuestionText QuestionTextTeacher" [question]="choice" [hideStudentManipControlBar]="true" textProperty="RenderQuestion"></kh-question-text>
